export default class ModSegmentCards {
  constructor(el) {
    this.$el = $(el);

    this.class = {
      segmentCardsOverlay: 'segment-cards-overlay',
    };

    this.elementClasses = {
      cardsItemChild: '.cards-item-child',
      listImageCardsItem: '.list-image-cards .image-card-item',
      arrowAnimation: '.arrow-animation',
      imageCardItem: '.image-card-item',
    };

    this.attribute = {
      opacity: 'opacity',
    };

    this.listImageSegments = this.$el.find('.list-image-cards');
    this.intervalTime = null;
    this.isHovering = true;

    this.init();
  }

  init() {
    this.addListeners();
  }

  addListeners() {
    $(this.elementClasses.cardsItemChild).on({
      mouseenter: (e) => {
        this.eventMouseEnterChangeImage(e);
      },
      mouseleave: () => {
        this.eventMouseLeaveChangeImage();
      },
    });
  }

  setOpacityForSegmentsAndArrow($elm, imageIndex) {

    $(this.elementClasses.arrowAnimation).css(this.attribute.opacity, '0');
    $elm.find(this.elementClasses.arrowAnimation).css(this.attribute.opacity, '1');

    $elm.find(this.elementClasses.listImageCardsItem).css(this.attribute.opacity, '0');
    $elm.find(this.elementClasses.listImageCardsItem).eq(imageIndex).css(this.attribute.opacity, '1');

    $(this.elementClasses.cardsItemChild).addClass(this.class.segmentCardsOverlay);
    $elm.removeClass(this.class.segmentCardsOverlay);
  }

  eventMouseEnterChangeImage(e) {
    if (window.innerWidth >= 1200) {
      const $elm = $(e.currentTarget);
      const lengthItem = $elm.find(this.elementClasses.listImageCardsItem).length;
      let imageIndex = 0;
      clearInterval(this.intervalTime);
      if (this.isHovering === true) {
        if (lengthItem > 2) {
          imageIndex = 1;
        }
        this.isHovering = false;

        this.setOpacityForSegmentsAndArrow($elm, imageIndex);
      }
      this.intervalTime = setInterval(() => {
        imageIndex++;
        imageIndex %= lengthItem;

        this.setOpacityForSegmentsAndArrow($elm, imageIndex);
      }, 1000);
    }
  }

  eventMouseLeaveChangeImage() {
    clearInterval(this.intervalTime);
    $(this.elementClasses.arrowAnimation).css(this.attribute.opacity, '0');

    $(`.${this.class.segmentCardsOverlay}`).removeClass(this.class.segmentCardsOverlay);

    this.listImageSegments.find(this.elementClasses.imageCardItem).css(this.attribute.opacity, '0');
    this.listImageSegments.each((_idx, elm) => {
      $(elm).find(this.elementClasses.imageCardItem).first().css(this.attribute.opacity, '1');
    });
    this.isHovering = true;
  }
}
